// ExcelUploader.jsx

import React, { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import '../css/ExcelUploader.css';

function ExcelUploader({ onDataParsed, children, customClass }) {
  const fileInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    setIsLoading(true); // Postavi loading stanje na true
  
    const reader = new FileReader();
    reader.onload = (evt) => {
      const fileExtension = file.name.split('.').pop().toLowerCase();
  
      if (fileExtension === 'csv') {
        // Handling CSV
        const csvData = evt.target.result;
        // Parse CSV data using XLSX.read with type 'binary'
        const workbook = XLSX.read(csvData, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        let json = XLSX.utils.sheet_to_json(worksheet);
  
        console.log('Raw CSV Data:', json);
        json = normalizeKeys(json);
        onDataParsed(json, file.name);
      } else {
        // Handling Excel (.xlsx, .xls)
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        let json = XLSX.utils.sheet_to_json(worksheet);
  
        console.log('Raw Excel Data:', json);
        json = normalizeKeys(json);
        onDataParsed(json, file.name);
      }
      
      setIsLoading(false); // Postavi loading stanje na false nakon završetka
    };
  
    if (file.name.endsWith('.csv')) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }

    // Reset file input nakon svakog pokušaja uploada
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  // Funkcija za normalizaciju ključeva i vrijednosti: mala slova bez praznina
  const normalizeKeys = (data) => {
    return data.map(item => {
      const normalizedItem = {};
      Object.keys(item).forEach(key => {
        // Normalizacija ključeva za Rider ID
        if (key.toLowerCase() === 'riderid' || key.toLowerCase() === 'rider id' || key.toLowerCase() === 'id') {
          normalizedItem['Id'] = item[key];
        }
        // Normalizacija ključeva za Total Amount
        else if (key.toLowerCase().includes('total amount') && key.toLowerCase().includes('tip')) {
          normalizedItem['Total Amount (w. tips)'] = item[key];
        }
        // Zadržavanje ostalih ključeva kakvi jesu
        else {
          normalizedItem[key] = item[key];
        }
      });
      return normalizedItem;
    });
  };

  return (
    <span
      className={`excel-uploader ${customClass || ''} ${isLoading ? 'loading' : ''}`}
      onClick={handleClick}
      style={{ cursor: 'pointer', textDecoration: 'underline' }}
    >
      {isLoading ? 'Učitavanje...' : children}
      <input
        type="file"
        accept=".xlsx, .xls, .csv"
        onChange={handleFileUpload}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
    </span>
  );
}

export default ExcelUploader;